const LoadingSpinner = ({ loadingType }) => {
    switch (loadingType) {
        case 'list':
            return (
                <>
                    <div className='headless-loading-list headless-loading-list-mobile'>
                        {Array.from({ length: 20 }).map((_, idx) => (
                            <div key={idx} className='placeholder-row'>
                                <div className='placeholder-box'></div>
                                <div className='placeholder-text'>
                                    <div className='placeholder-line'></div>
                                    <div className='placeholder-line'></div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='headless-menu-placeholder headless-loading-list-desktop'>
                        {Array.from({ length: 12 }).map((_, idx) => (
                            <div key={idx} className="menu-placeholder-card">
                                <div className="card-image"></div>
                                <div className="card-text">
                                    <div className="card-line"></div>
                                    <div className="card-line"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            );
        case 'menuList':
            return (
                <div className='headless-menu-placeholder-simple'>
                    <svg
                        className="menu-loading-spinner"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 50 50"
                        width="50"
                        height="50"
                    >
                        <circle
                            cx="25"
                            cy="25"
                            r="20"
                            fill="none"
                            strokeWidth="4"
                            strokeLinecap="round"
                        >
                            <animate
                                attributeName="stroke-dasharray"
                                dur="1.5s"
                                repeatCount="indefinite"
                                values="1,150;90,150;90,150"
                            />
                            <animate
                                attributeName="stroke-dashoffset"
                                dur="1.5s"
                                repeatCount="indefinite"
                                values="0;-35;-124"
                            />
                        </circle>
                    </svg>
                    <p className="menu-loading-text">Loading menu</p>
                </div>
            );
        case 'shopNav':
            return (
                <div className='headless-loading-shopnav'></div>
            );
        case 'productNav':
            return (
                <div className='headless-loading-list headless-loading-productnav'></div>
            );
        case 'filter':
            return (
                <div className='headless-loading-filter'></div>
            );
        case 'slider':
            return (
                <div className='headless-loading-slider'>
                    {Array.from({ length: 5 }).map((_, idx) => (
                        <div key={idx} className='placeholder-card'>
                            <div className='card-image'></div>
                            <div className='card-text'>
                                <div className='card-line'></div>
                                <div className='card-line'></div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        case 'menuBanners':
            return <div className='headless-loading-banners'></div>;
        case 'slider-smaller':
            return (
                <div className='headless-loading-slider loading-slider-smaller'>
                    {Array.from({ length: 5 }).map((_, idx) => (
                        <div key={idx} className='placeholder-card'>
                            <div className='card-image'></div>
                            <div className='card-text'>
                                <div className='card-line'></div>
                                <div className='card-line'></div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        default:
            return (
                <div className="headless-loading-spinner">
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        style={{ enableBackground: "new 0 0 50 50" }}
                        xmlSpace="preserve"
                    >
                        <rect x="0" y="0" width="4" height="7" fill="#333">
                            <animateTransform
                                attributeType="xml"
                                attributeName="transform"
                                type="scale"
                                values="1,1; 1,3; 1,1"
                                begin="0s"
                                dur="0.6s"
                                repeatCount="indefinite"
                            />
                        </rect>
                        <rect x="10" y="0" width="4" height="7" fill="#333">
                            <animateTransform
                                attributeType="xml"
                                attributeName="transform"
                                type="scale"
                                values="1,1; 1,3; 1,1"
                                begin="0.2s"
                                dur="0.6s"
                                repeatCount="indefinite"
                            />
                        </rect>
                        <rect x="20" y="0" width="4" height="7" fill="#333">
                            <animateTransform
                                attributeType="xml"
                                attributeName="transform"
                                type="scale"
                                values="1,1; 1,3; 1,1"
                                begin="0.4s"
                                dur="0.6s"
                                repeatCount="indefinite"
                            />
                        </rect>
                    </svg>
                </div>
            );
    }
};

export default LoadingSpinner;
